// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_164uPm2fo9QkloGhpfKqRi","checked":"_2NJ3BVboT-tGUQgEvHobj3","disabled":"_3_FDU2-E0S4qRswoplQ4pp","selected":"_1w58LJ_T74qaqVDWhMsMSR"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/oddsButton.css
// module id = 760
// module chunks = 0